import { TableGroup, TableColumns } from 'Components/Common/Table/TableGroup';

import React, { useCallback, useMemo } from 'react';
import { formatCurrency } from 'Utils/Numbers';
import { COL_END_CLASS } from 'Constant';

const TableSaleMonth = ({
  dataSource,
  saleChannels,
}: {
  dataSource: any[];
  saleChannels: any[];
}): JSX.Element => {
  const renderChannelColumnTotal = useCallback(() => {
    return [
      {
        text: '',
        width: 80,
        bgColorCol: 'bg-dark',
        textColorCol: 'text-white',
        dataIndex: 'channelName',
        render: ({ item }: { item: any }) => {
          return <div className={`text-truncate mw-250 text-start`}>{item.channelName}</div>;
        },
      },
      {
        text: '販売数',
        width: 80,
        dataIndex: 'totalAmount',
        render: ({ item }: { item: any }) => {
          return <div className={`${COL_END_CLASS}`}>{formatCurrency(item.totalAmount || 0)}</div>;
        },
      },
      {
        text: '販売金額（税抜）',
        width: 80,
        dataIndex: 'totalMoney',
        render: ({ item }: { item: any }) => {
          return <div className={`${COL_END_CLASS}`}>{formatCurrency(item.totalMoney || 0)}</div>;
        },
      },
      {
        text: '販売金額（税込）',
        width: 80,
        dataIndex: 'totalAmount',
        render: ({ item }: { item: any }) => {
          return (
            <div className={`${COL_END_CLASS}`}>{formatCurrency(item.afterTaxTotalMoney || 0)}</div>
          );
        },
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saleChannels]);

  const mergedData = saleChannels
    .map((channel, index) => {
      const data = dataSource?.[0];
      return {
        channelName: channel.channelName,
        totalAmount: data?.[`totalAmount${index}`] || 0,
        totalMoney: data?.[`totalMoney${index}`] || 0,
        afterTaxTotalMoney: data?.[`afterTaxTotalMoney${index}`] || 0 || 0,
      };
    })
    .concat([
      {
        channelName: '合計',
        totalAmount: dataSource?.[0]?.totalAmount || 0,
        totalMoney: dataSource?.[0]?.totalMoney || 0,
        afterTaxTotalMoney: dataSource?.[0]?.afterTaxTotalMoney || 0,
      },
    ]);

  const columnTotals = useMemo(
    () =>
      [
        {
          columns: renderChannelColumnTotal(),
        },
      ] as TableColumns[],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [renderChannelColumnTotal, saleChannels?.length],
  );

  return (
    <div className="d-flex flex-column" style={{ width: '100%' }}>
      <div className="me-3" style={{ width: '100%', marginTop: '18px' }}>
        <TableGroup dataSource={mergedData} tableColumns={columnTotals} />
      </div>
    </div>
  );
};
export default TableSaleMonth;
